import React from 'react';
import { useSelector } from 'react-redux';
import t from 'utils/translate';
import {
    resetContactsSelectorData,
    selectContactsPageData,
    updateContactsPageData,
    updateSearchInputData,
    getContactsSelectorData,
} from '../stores/contacts-slice-handler';
import ContactsSelectorClient from './contacts-selector-client';
import Preloader from '../../shared/components/preloader';
import { SearchInputDefaultData } from 'constants/contacts-constants';

export default function ContactsPageMainArea() {
    /**
     * @type {ContactsPageData}
     */
    const contactsPageData = useSelector(selectContactsPageData);
    const resetSearch = () => {
        const selectorData = getContactsSelectorData(contactsPageData.contactsSelectorUuid);
        updateSearchInputData(selectorData.usersSearchInputId, SearchInputDefaultData);
        updateSearchInputData(selectorData.groupsSearchInputId, SearchInputDefaultData);
    };

    return (
        <div className="contacts-page-main-area">
            {contactsPageData.dataIsUpdating && <Preloader asOverlay />}
            {contactsPageData.globalAction !== null ? (
                <ContactsSelectorClient
                    contactsSelectorUuid={contactsPageData.contactsSelectorUuid}
                    options={{
                        action: contactsPageData.globalAction,
                        cancelCallback: () => {
                            updateContactsPageData({ globalAction: null });
                            resetSearch();
                            resetContactsSelectorData(contactsPageData.contactsSelectorUuid);
                        },
                    }}
                ></ContactsSelectorClient>
            ) : (
                <div className="cta">{t('js_all_contact_create_conversation')}</div>
            )}
        </div>
    );
}
